import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { alpha } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import Logo from 'src/components/logo';
import Iconify from 'src/components/iconify';

import {FooterMenu} from "../../components/fofoo-menu";

// ----------------------------------------------------------------------
// ----------------------------------------------------------------------

function Footer({menuData}) {
  const mainFooter = (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        bgcolor: 'background.default',
      }}
    >
      <Divider />

      <Container
        sx={{
          pt: 10,
          pb: 5,
          textAlign: { xs: 'center', md: 'unset' },
        }}
      >
        <Logo sx={{ mb: 3 }} />

        <Grid
          container
          justifyContent={{
            xs: 'center',
            md: 'space-between',
          }}
        >
          <Grid xs={8} md={3}>
            <Typography
              variant="body2"
              sx={{
                maxWidth: 270,
                mx: { xs: 'auto', md: 'unset' },
              }}
            >
              Kuliguli to miejsce, gdzie miłość do jedzenia łączy ludzi. Dodawaj przepisy, oceniaj, inspiruj się i gotuj razem z innymi głodomorami.
            </Typography>
          </Grid>

          <Grid xs={12} md={6}>
            <FooterMenu id="fofoo-footer-menu" items={menuData.items}/>
          </Grid>
        </Grid>

        <Typography variant="body2" sx={{ mt: 10 }}>
          © 2026 kuliguli.pl
        </Typography>
      </Container>
    </Box>
  );

  return mainFooter;
}

Footer.propTypes = {
  menuData: PropTypes.object
};

export default Footer;
